import {
  UPDATE_PROJECT_ACTION,
} from '../actions/projectAction';

const INITIAL_STATE = { action: null };

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UPDATE_PROJECT_ACTION:
      console.log('update project action: ', {
        action: action.projectAction.action
      })
      return {
        action: action.projectAction.action
      }
    default:
      return state
  }
};


// WEBPACK FOOTER //
// ./src/reducers/projectAction.js